<template>
    <div class="mopkup_box_preview" id="mopkup_box_preview">
        <div v-if="!OnShowCanvas">
            <Skeleton/>
        </div>
        <div v-else style="position: relative;">
            <v-stage 
                ref="stateCanvas"
                v-if="this.mockups()[0] !== null"
                :config="stageConfig"
                class="omcustom-preview-print-mockup"
                :style="style"
            >
                <v-layer>
                    <v-rect
                    :config="{
                        width: stageConfig.width / stageConfig.scale.x,
                        height: stageConfig.height / stageConfig.scale.x,
                        fill: '#ffffff'
                    }"
                    />
                    
                    <template v-for="l in this.mockups()[0].layers">
                        <group
                            v-if="l.type === 'Group'"
                            :layer="l"
                            :key="l.id"
                            :mockupID="this.mockups()[0].id"
                            :ratio="mockupsID"
                        />
                        <m-image
                            v-if="l.type === 'Image'"
                            :layer="l"
                            :key="l.id"
                            :mockupID="mockupsID"
                        />
                        <PrintAreaMocups
                            v-if="l.type === 'Printarea'"
                            :layer="l"
                            :key="l.id"
                            :ratio="ratio"
                            :name_layer="name_layer"
                            @setPrintAreaConfig="setPrintAreaConfig"
                            @setArtworkWidth="setArtworkWidth"
                            :rotation="rotation"
                        />
                    </template>   
                    <v-text
                        ref="textRef"
                        :config="{...configTextCopyright}"
                    />
                    <v-transformer
                        ref="transformer"
                        shouldOverdrawWholeArea="true"
                        @transformend="onTransformend"
                        @dragend="onDragMove"
                    />                
                    
                </v-layer>

            </v-stage>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import jQuery from 'jquery'
import Skeleton from '../Utilities/Skeleton'
import Group from "../Mockup/Group"
import Image from '../Mockup/Image'
import {map, get, pick, concat, max} from 'lodash'
import PrintAreaMocups from './PrintAreaMocups'
export default{
    name: "PreviewPrintMockups",
    components: {
        Skeleton,
        group: Group,
        'm-image': Image,
        PrintAreaMocups
    },
    props: {
        name_layer: {
            type: String,
            default(){
                return "";
            }
        },
        rotation: {
            type: Number,
            default(){
                return 1;
            }
        },
    },
    data(){
        return {
            OnShowCanvas: false,
            boxSize: {},
            selectedShapeName: '',
            isDragging: false,
            dataSetArtworkWidth: 1000
        }
    },
    mounted() {
        jQuery('.konvajs-content')
        .removeClass('konvajs-content')
        .addClass('fabric-content')
        this.selectedShapeName = this.name_layer;
        const { mockups } = this
        const OnThis = this;
        const mockupss = get(this.mockups()[0], 'layers');
        let layers = mockupss.find((e)=> e.type == "Printarea");
        localStorage.setItem('layersPreview_'+ this.name_layer, JSON.stringify(layers));
        this.$emit('setScaleNow', this.scaleNow());
        const box_preview = jQuery('#mopkup_box_preview');
        if(box_preview.length >= 1){
            const mockup = mockups()[0];
            const width_box = box_preview.width();
            const x = width_box / mockup.width;
            const boxSize = {
                width: mockup.width * x,
                height: mockup.height * x,
                ratio: x
            }
            this.boxSize = boxSize;
            setTimeout(()=> {
                OnThis.OnShowCanvas = true;
                setTimeout(()=> {
                    OnThis.updateTransformer();
                }, 500);
            });
        }
    },
    computed: {
        configTextCopyright(){
            const text = this.getHostName();
            var fontSize = this.calculateFontSize(this.stageConfig.width, text);
            const config = {
                align: 'center',
                ellipsis: true,
                fill: '#ABB8C3',
                fillAfterStrokeEnabled: true,
                fillPriority: 'color',
                fontFamily: 'fXmXx0Mxgz-regular',
                fontSize: fontSize / this.stageConfig.scale.x,
                // height: this.stageConfig.height / this.stageConfig.scale.y,
                letterSpacing: 1.3017384557620613 * 8,
                lineHeight: 1,
                offsetX: 0,
                offsetY: 0,
                padding: 0,
                ratio: 0.1,
                rotation: 0,
                scaleX: 1,
                scaleY: 1,
                skewX: 0,
                skewY: 0,
                type: 'Text',
                verticalAlign: 'middle',
                visible: true,
                width: this.stageConfig.width  / this.stageConfig.scale.x,
                wrap: 'none',
                wrapConfig: 'word',
                x: 1,
                y: 1,
                listening: true,
                text: text  //this.getHostName(),
            }
            return config;
        },
        artworkWidth() {
            const { mockups, boxSize } = this
            var mockupsRatio = mockups()[0].width / mockups()[0].height
            var printAreaRatio = boxSize.width / boxSize.height
            if (mockupsRatio >= printAreaRatio) {
                return boxSize.width
            } else {
                return boxSize.height * mockupsRatio
            }
        },
        ratio() {
            const { mockups } = this
            return mockups()[0].width <= 1000 ? 1 : 1000 / mockups()[0].width
        },
        stageConfig() {
            const { boxSize } = this
            return {
                width: boxSize.width ? boxSize.width : 650,
                height: boxSize.height ? boxSize.height : 535,
                scale: { x: boxSize.ratio ? boxSize.ratio : 0.1, y: boxSize.ratio ? boxSize.ratio : 0.1 },
                listening: true
            }
        },
        style() {
            const { mockups } = this
            return {
                position: 'relative',
                height: 0,
                paddingBottom: `${(mockups()[0].height / mockups()[0].width) * 100}%`
            }
        },
        layerPrintarea(){
            const { mockups } = this;
            const findPrintarea = mockups()[0].layers.find(e => e.type == "Printarea");
            return findPrintarea ? findPrintarea : null
        },
        mockupsID(){
            const { mockups } = this
            return mockups()[0].id;
        }
    },
    created() {
       
    },
    watch: {
        
    },
    methods: {
        ...mapGetters(['template', 'personalized', 'mockupLoadings', 'mockups', 'artworks', 'siteURL']),
        ratioNow() {
            var ratio = 1
            if (this.artworks()[0].width && this.artworks()[0].height) {
                var r = max([this.artworks()[0].width, this.artworks()[0].height])
                var res = 10
                for (; res > 1; res--) {
                if (r * res <= 10000) {
                    break
                }
                }
                ratio = res / 10
            }
            return ratio
        },
        scaleNow(){
            return this.dataSetArtworkWidth / (this.artworks()[0].width * this.ratioNow());
        },
        onDragMove(e){
            const node = e.target._nodes[0];
            const id = node.id();
            const attrs = node.attrs;
            let config = {};
            config.x = attrs.x;
            config.y = attrs.y;
            
            this.$emit('onChangeConfigImage', {
                id: this.selectedShapeName,
                scale:  this.scaleNow(),
                configs: config 
            });
        },
        calculateFontSize(boxWidth, text) {
            var fontSizeMin = 1; // Kích thước font chữ tối thiểu
            var fontSizeMax = 70; // Kích thước font chữ tối đa
            var container = document.createElement('div');
            container.style.visibility = 'hidden';
            container.style.position = 'absolute';
            container.style.width = 'auto';
            container.style.height = 'auto';
            container.style.whiteSpace = 'nowrap';
            container.style.fontSize = fontSizeMax + 'px'; // Bắt đầu với kích thước font tối đa
            container.innerHTML = text;
            document.body.appendChild(container);
            // Binary search để xác định kích thước font chữ phù hợp
            while (fontSizeMax - fontSizeMin > 1) {
                var fontSizeMid = Math.floor((fontSizeMin + fontSizeMax) / 2);
                container.style.fontSize = fontSizeMid + 'px';
                if (container.clientWidth > boxWidth) {
                fontSizeMax = fontSizeMid;
                } else {
                fontSizeMin = fontSizeMid;
                }
            }
            document.body.removeChild(container);
            return fontSizeMin;
        },
        getHostName(){
            const hostName = window.location.hostname;
            const link = hostName.replace("https://", "");
            const name = link.charAt(0).toUpperCase() + link.slice(1)
            return name;
        },
        updateTransformer() {
            const transformerNode = this.$refs.transformer.getNode();
            const stage = transformerNode.getStage();
            const { selectedShapeName } = this;

            const selectedNode = stage.findOne('.' + selectedShapeName);
            
            if (selectedNode === transformerNode.node()) {
                return;
            }
            if (selectedNode) {
                transformerNode.nodes([selectedNode]);
            } else {
                transformerNode.nodes([]);
            }
        },
        onTransformend(e){
            const transformerNode = this.$refs.stateCanvas.getNode();
            const stage = transformerNode.getStage();
            const { selectedShapeName } = this;
            const selectedNode = stage.findOne('.' + selectedShapeName);
            const attrs = selectedNode.attrs;
            let config = {};
            config.scaleX = attrs.scaleX;
            config.scaleY = attrs.scaleY;
            config.rotation = attrs.rotation;
            config.skewX = attrs.skewX;
            config.skewY = attrs.skewY;
            config.x = attrs.x;
            config.y = attrs.y;
            this.$emit('onChangeConfigImage', {
                id: this.selectedShapeName,
                scale:  this.scaleNow(),
                configs: config
            });
        },
        setPrintAreaConfig(v){
            this.dataSetPrintAreaConfig = v;
        },
        setArtworkWidth(v){
            this.dataSetArtworkWidth = v;
        }
    },
}
</script>

<style>
.omcustom-preview-print-mockup{
  width: 100% !important;
}

.omcustom-preview-print-mockup .fabric-content canvas {
  width: 100% !important;
  height: auto !important;
  background-color: #e6e6e6 !important;
}
@media only screen and (max-width: 739px){
  .box-container-modal-cutface .omcustom-preview-print-mockup .fabric-content {
    width: 100% !important;
    overflow: hidden;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/PreviewMockups/PreviewPrintMockups.vue